$('.ttgAnfrageFormular input, .ttgAnfrageFormular textarea').on('focus', function() {
    var sitekey = $(".ttgAnfrageFormular").find('.google-recaptcha').data('sitekey');
    var head = document.getElementsByTagName('head')[0];
    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://www.google.com/recaptcha/api.js?render=' + sitekey;
    script.setAttribute('defer', '');
    head.appendChild(script);

    $('.ttgAnfrageFormular input, .ttgAnfrageFormular textarea').off('focus');
});

//Kataloge
if ($("#ttgKatalogForm .google-recaptcha").length) {
    $('#ttgKatalogForm input, #ttgKatalogForm textarea').on('focus', function() {
        var sitekey = $("#ttgKatalogForm .google-recaptcha").data('sitekey');
        var head = document.getElementsByTagName('head')[0];
        var script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://www.google.com/recaptcha/api.js?onload=onloadCallbackKatalog&render=' + sitekey;
        script.setAttribute('defer', '');
        head.appendChild(script);
    });
}

var onloadCallbackKatalog = function() {
    grecaptcha.ready(function() {
        grecaptcha.execute($("#ttgKatalogForm").find('.google-recaptcha').data('sitekey'), {
            action: 'submitKatalog'
        }).then(function(token) {
            $('#ttgKatalogForm input[type="hidden"][name="g-recaptcha-response"]').val(token);
        });
    });
};

// var renderReCaptcha = function() {
//
//     $('.ttgAnfrageForm, #ttgGewinnspielForm').each(function() {
//         var el = $(this).find('.google-recaptcha');
//         /* ACHTUNG: grecapcha braucht als container unbedingt ein Element mit einer ID */
//         grecaptcha.render(
//             $(el).attr('id'), {
//                 'sitekey': el.data('sitekey')
//             }
//         );
//     });
// };